import React from "react";

// Utilitários de "pesquisar dentro do arquivo aberto" nos viewers (XML/TXT/JSON).
// A marca só pinta o fundo (color: inherit), então o realce de sintaxe é mantido.

// Conta ocorrências (case-insensitive) de query em raw.
export function countMatches(raw, query) {
  if (!raw || !query) return 0;
  const q = String(query).toLowerCase();
  if (!q) return 0;
  const hay = String(raw).toLowerCase();
  let n = 0;
  let i = hay.indexOf(q);
  while (i !== -1) {
    n += 1;
    i = hay.indexOf(q, i + q.length);
  }
  return n;
}

// Quebra um texto destacando as ocorrências de query num <mark>. Retorna a própria
// string quando não há query/match (para o React renderizar igual). keyBase mantém
// as keys únicas dentro do span pai.
export function withSearch(text, query, keyBase) {
  const q = query ? String(query).toLowerCase() : "";
  if (!q) return text;
  const src = String(text);
  const low = src.toLowerCase();
  let i = low.indexOf(q);
  if (i === -1) return text;
  const parts = [];
  let from = 0;
  let k = 0;
  while (i !== -1) {
    if (i > from) parts.push(src.slice(from, i));
    parts.push(
      <mark
        key={`${keyBase}-m-${k++}`}
        style={{ background: "var(--everlog-search-hit, #ffd54a)", color: "inherit", borderRadius: 2, padding: "0 1px" }}
      >
        {src.slice(i, i + q.length)}
      </mark>
    );
    from = i + q.length;
    i = low.indexOf(q, from);
  }
  if (from < src.length) parts.push(src.slice(from));
  return parts;
}
